import { createRoot } from "react-dom/client";
import * as dasha from "@dasha.ai/sdk/web";
import * as Sentry from "@sentry/react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager } from "styled-components";

import App from "./app";
import ErrorBoundary from "./ErrorBoundary";
import './semantic-ui/semantic.less';

// Sentry.init({
//   dsn: "https://4259193be5fe4edd894cb12bcfe696d5@sentry.dev.az.dasha.ai/45",
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 1.0,
// });

dasha.log.on("data", ({ level, message, stack }) => {
  if (level !== "error") return;
  const err = new Error(message);
  err.stack = stack;
  Sentry.captureException(err);
});

const SentryApp = Sentry.withErrorBoundary(App, { fallback: ErrorBoundary });

// styled-components 6 forwards all props to the DOM by default; restore the
// v5 filtering for DOM tags until custom props are migrated to $transient ones.
const forwardV5 = (propName: string, target: unknown) =>
  typeof target === "string" ? isPropValid(propName) : true;

createRoot(document.getElementById("root")!).render(
  <StyleSheetManager shouldForwardProp={forwardV5}>
    <SentryApp />
  </StyleSheetManager>
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw.js", { scope: "/" })
    .then((reg) => {
      console.log("Registration succeeded. Scope is " + reg.scope);
    })
    .catch((error) => {
      console.log("Registration failed with " + error);
    });
}
